import React from 'react';
import './CreditCardButton.scss';

export const CreditCardButton = ({ text }) => {
    return <button className="credit-card-button">{text}</button>;
};
